// worker.js
const workercode = () => {
    //const webSocket = new WebSocket(`ws://localhost:8765`);
    var self = this
    self.onmessage = function (e) {
        //var bitmap = e.data.bitmap;
        //webSocket.send(e.data.name);
        /* var offscreen = new OffscreenCanvas(bitmap.width, bitmap.height);
        const ctx = offscreen.getContext("bitmaprenderer"); */
        //ctx.canvas.width = bitmap.width;
        //ctx.canvas.height = bitmap.height;
        //ctx.drawImage(bitmap, 0, 0);
        //const imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
        /* ctx.transferFromImageBitmap(bitmap);
        offscreen.convertToBlob().then(function (blob) {
            var imgobj = new Object();
            imgobj.name = e.data.name
            imgobj.data = blob
            webSocket.send(e.data.name);
            //self.postMessage(imgobj);
        }
        ); */

        // var bitmap = e.data;
        // const ctx = new OffscreenCanvas(1, 1).getContext('2d');
        // ctx.canvas.width = bitmap.width;
        // ctx.canvas.height = bitmap.height;
        // ctx.drawImage(bitmap, 0, 0);
        // const imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
        // //const data = new Uint8Array(imgData.data);
        // console.log(imgData.data);
        // postMessage({
        //     width: imgData.width,
        //     height: imgData.height,
        //     data: data.buffer,
        // }, [data.buffer]);
        //console.log('Message received from main script');
        //var workerResult = 'Received from main: ' + (e.data);
        //console.log('Posting message back to main script');
        //self.postMessage("work completed");
    }
};


let code = workercode.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const worker_script = URL.createObjectURL(blob);

module.exports = worker_script;